/*
 * @Author: XuJingXin v_xujingxin@tal.com
 * @Date: 2024-11-11 16:13:17
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @LastEditTime: 2024-11-27 17:00:35
 * @FilePath: /sea_parent_webapp/src/containers/app/ht.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { 
    createHashHistory,
    // createBrowserHistory 
    } from 'history'

const history = createHashHistory()

export default history
